<template>
  <m-pay-layout>

      <v-layout justify-center align-top class="mx-2">
        <v-flex grow>
          <m-pay-generic-paging-table
            :headers="headers"
            :queryFunctionName="queries.merchantWidgets.name"
            :cellClasses="cellClasses"
          >
            <template slot-scope={item} slot="details">
              <router-link :to="{ name: 'widget', params: { widgetId: item.id } }">
                <v-tooltip bottom>
                      <span slot="activator">
                        <v-icon color="secondary">zoom_in</v-icon>
                      </span>
                  <span>Widget Details</span>
                </v-tooltip>
              </router-link>
            </template>
            <template slot-scope={item} slot="clone">
              <router-link :to="{ name: 'add-widget', query: { id: item.id,
                totalAmount: item.total_amount,
                totalCurrency: item.total_currency,
                totalLabel: item.total_label,
                type: item.type,
                orderAuthorizationType: item.orderAuthorizationType,
                totalTaxRate: item.total_taxRate} }">
                <v-tooltip bottom>
                      <span slot="activator">
                        <v-icon color="secondary">queue</v-icon>
                      </span>
                  <span>Clone Widget</span>
                </v-tooltip>
              </router-link>
            </template>
            <template slot-scope={value} slot="id">
              <m-pay-copy-button :value="value" showValue></m-pay-copy-button>
            </template>
            <template slot-scope={value} slot="htmlCode">
              <m-pay-copy-button :value="value"></m-pay-copy-button>
            </template>
            <template slot-scope={value} slot="status">
              <m-pay-status :value-classes="widgetStatusClasses" :value="value"/>
            </template>
            <template slot-scope={value} slot="type">
              <m-pay-status :value-classes="widgetTypeClasses" :value="value"/>
            </template>
            <template slot-scope={value} slot="orderAuthorizationType">
              <m-pay-status :value-classes="widgetOrderAuthorizationTypeClasses" :value="value"/>
            </template>
            <template slot-scope={value} slot="creationMethod">
              <m-pay-status :value-classes="widgetCreationMethodClasses" :value="value"/>
            </template>
          </m-pay-generic-paging-table>
          <v-btn class="ml-0"
               color="secondary"
               @click.native="addWidget">
            Create
            <v-icon right dark>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

    </m-pay-layout>
</template>

<script>
import MPayGenericPagingTable from '../MPayGenericPagingTable';
import MPayCopyButton from '../MPayCopyButton';
import MPayStatus from '../MPayStatus';
import {
  widgetStatusClasses, widgetCreationMethodClasses,
  widgetTypeClasses, widgetOrderAuthorizationTypeClasses,
} from '../../utils/statuses';

export default {
  name: 'MPayMerchantWidgetsPage',
  components: { MPayGenericPagingTable, MPayCopyButton, MPayStatus },
  data: () => ({
    merchantEmployees: [],
    totalMerchantEmployees: 0,
    merchant: {},
    headers: [
      { text: '', value: 'details', sortable: false, filterable: false },
      { text: '', value: 'clone', sortable: false, filterable: false },
      { text: 'ID', value: 'id', align: 'center', sortable: true, filterable: true },
      { text: 'Name', value: 'name', filterable: true },
      { text: 'HTML Code', value: 'htmlCode', align: 'center', sortable: false, filterable: false },
      { text: 'Status', value: 'status' },
      { text: 'Type', value: 'type', sortable: true, filterable: true },
      { text: 'Order Authorization Type', value: 'orderAuthorizationType', sortable: true, filterable: true },
      { text: 'Create Method', value: 'creationMethod' },
      { text: 'Amount', value: 'amount', filterable: false },
      { text: 'Total Amount', value: 'totalAmount', filterable: false, align: 'right' },
      { text: 'Tax Amount', value: 'taxAmount', filterable: false },
    ],
    cellClasses: {
      details: 'pl-3 pr-1',
    },
    loading: false,
    widgetStatusClasses,
    widgetCreationMethodClasses,
    widgetTypeClasses,
    widgetOrderAuthorizationTypeClasses,
  }),
  methods: {
    addWidget() {
      this.$router.push({ name: 'add-widget' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantWidgetsPage.vue